import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TripleForwardHelixPiercingImage from '../../Assets/Piercing Services/triple forward helix piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TripleForwardHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Triple Forward Helix Piercing UAE | 350 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Triple Forward Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Triple Forward Helix Piercing 350 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TripleForwardHelixPiercingImage} alt="Triple Forward Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Triple Forward Helix Piercing</h3>

          <p>
            Make a bold and unforgettable style statement with our professional triple forward helix piercing services in the UAE, available at an affordable price of 350 AED. Triple forward helix piercing is a striking and modern cartilage piercing that features three precisely aligned piercings on the front outer rim of the ear, just above the tragus. This triple-layered design creates a standout and eye-catching look, perfect for individuals who want to express their personality with confidence and elevate their ear styling to the next level. Whether you prefer minimal studs for a sleek aesthetic or a mix of jewelry for a more dramatic effect, our expert specialists ensure precise placement for a balanced and visually stunning result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each triple forward helix piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Since this piercing involves multiple cartilage points, our skilled specialists use advanced techniques to reduce discomfort and make the procedure as quick and efficient as possible while maintaining the highest level of precision.
          </p>

          <p>
            Triple forward helix piercing is ideal for those who want a bold, layered ear design that truly stands out. It pairs beautifully with other ear piercings such as lobe, helix, tragus, or conch, allowing you to create a fully customized and curated ear style. Our specialists provide personalized consultation to understand your preferences and recommend the best spacing, alignment, and jewelry options that suit your ear structure and desired look. This ensures that your piercing not only looks stylish but also complements your overall appearance perfectly.
          </p>

          <p>
            The procedure is typically completed within a short time, even with three piercings, making it convenient for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process. Our goal is to deliver a comfortable, safe, and stylish experience from start to finish.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that multiple cartilage piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to guide you, answer your questions, and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for triple forward helix piercings, and we provide detailed instructions to help you maintain proper care during the healing process. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your piercing will heal effectively and remain a bold and stylish feature of your look.
          </p>

          <p>
            Our triple forward helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted triple forward helix piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong focus on customer satisfaction, we help you achieve a standout layered look effortlessly. Book your triple forward helix piercing appointment today and redefine your ear styling with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Triple Forward Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TripleForwardHelixPiercing;